import { render, staticRenderFns } from "./FooterForLanding.vue?vue&type=template&id=41f71ef5&scoped=true"
import script from "./FooterForLanding.vue?vue&type=script&lang=js"
export * from "./FooterForLanding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41f71ef5",
  null
  
)

export default component.exports